import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const ReferralStatsResponseSchema = z
  .object({
    data: z.object({
      total_referrals: z.number(),
      total_profit: z.number(),
      referral_commission: z.number(),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TReferralStatsResponse = z.infer<typeof ReferralStatsResponseSchema>;
export type TReferralStatsData = z.infer<typeof ReferralStatsResponseSchema>['data'];
